import React from 'react';
import { Pagination } from 'react-bootstrap';

const ServerPagination = ({ total, limit, current, onChange }) => {
  // Calculate total number of pages (e.g., 55 total / 10 limit = 6 pages)
  const totalPages = Math.ceil(total / limit);
  // Don't show pagination if there's only one page
  if (totalPages <= 1) return null;

  let items = [];
  for (let number = 1; number <= totalPages; number++) {
    items.push(
      <Pagination.Item 
        key={number} 
        active={number === current} 
        onClick={() => onChange(number)}
      >
        {number}
      </Pagination.Item>
    );
  }

  return (
    <div className="d-flex justify-content-center my-4">
      <Pagination>
        <Pagination.First onClick={() => onChange(1)} disabled={current === 1} />
        <Pagination.Prev onClick={() => onChange(current - 1)} disabled={current === 1} />
        
        {items}
        
        <Pagination.Next onClick={() => onChange(current + 1)} disabled={current === totalPages} />
        <Pagination.Last onClick={() => onChange(totalPages)} disabled={current === totalPages} />
      </Pagination>
    </div>
  );
};

export default ServerPagination;